const SkeletonBlock = ({ count, widthClass, imageHeight, textWidth }) => {
  return (
    <>
      <div className="mt-6 mb-4 h-4 w-36 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex flex-wrap gap-6">
        {[...Array(count)].map((_, index) => (
          <div key={index} className={`${widthClass} rounded-lg shadow bg-white`}>
            <div className="animate-pulse p-4">
              <div className={`${imageHeight} bg-gray-200 rounded-md mb-4`}></div>
              <div className={`h-4 ${textWidth} bg-gray-300 rounded`}></div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const CardSkeleton = () => (
  <SkeletonBlock count={3} widthClass="w-[235px]" imageHeight="h-48" textWidth="w-1/2" />
);

const BoxSkeleton = () => (
  <SkeletonBlock count={2} widthClass="w-[calc(50%-12px)]" imageHeight="h-60" textWidth="w-52" />
);

const HorizontalSkeleton = () => (
  <SkeletonBlock count={1} widthClass="w-full" imageHeight="h-48" textWidth="w-1/2" />
);

export { CardSkeleton, BoxSkeleton, HorizontalSkeleton };
